import { Component, OnInit } from "@angular/core";
import {
  enterAnimationFirst,
  enterAnimationSecond,
  enterAnimationThird,
} from "@app/shared/page-state/animations";

@Component({
  selector: "om-svg-physicians",
  templateUrl: "./svg-physicians.component.html",
  styleUrls: [],
  animations: [enterAnimationFirst, enterAnimationSecond, enterAnimationThird],
})
export class SvgPhysiciansComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
